export default function displayDurationFloatFormat(value, type = "seconds") {
  const seconds = type === "minutes" ? value * 60 : value;
  const minutes = parseInt(seconds / 60);
  const remainder = seconds % 60;
  const s = remainder / 60;
  const total = minutes + s;
  return total.toLocaleString("en", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
